import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
// /import Select from "@mui/material/Select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchImg from "../../Assets/AppComponent/Arrow/Layer_1@2x.png";
import createImg from "../../Assets/AppComponent/Arrow/Vector (3).png";
// import {
//   useTable,
//   useFilters,
//   useSortBy,
//   usePagination,
//   useGlobalFilter,
// } from "react-table";
import {
  useTable,
  useSortBy,
  usePagination,
  useFilters,
  useGlobalFilter,
} from "react-table";

import { useMemo, useState } from "react";
import "../../StyleSheet/AppComponent/ReactTable/ReactTable.scss";
import SearchIcon from "@mui/icons-material/Search";
import Select from "react-select";
import zIndex from "@material-ui/core/styles/zIndex";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import boximg from "../../Assets/AppComponent/freepik--Folder--inject-62.svg";
import boximg from "../../Assets/AppComponent/Group 427320177.svg";
import MonthFilter_datepicker from "./MonthFilter";

var pageindexloc;

const ReactTable = (props) => {
  //const { totalItems, pageSize, currentPage, onPageChange } = props;
  const {
    MakeCreate,
    view,
    Filter,
    options,
    values,
    setCurrentPage,
    placeHold,
    /// employee role based filters
    EmployeeRoleTrue,

    EmployeeRoleOption,
    EMpROleSelected,
    ///---Month based filter ,
    MonthFilter,
    yearAndMonth,
    ///---App side completed list in  website ,
    AppSideView,
    AllEmp,
    optionsforfilter,
    ///----old employees-
    oldemloyeeOptions,
    OldEmployeFilters,
    OldEmp,
    ///--supervisor--filter
    Superviorsfilter,
    supervisoreOptions,
    TypeOfsuperviors,
    nostatusFilter,
    ///-----Parents--skill type listed---
    typeOfParent,
    typeOfParentlist,
    EMpHeaderSelected,

    ///---rm---filter---
    Rmfilter,
    Rmoptions,
    RMStatusFilter,
    Search,

    // kyc---role---filter
    KYCoptionsTable,
    KYC,
    KycValue,
    //--payroll
    PayrollFilter,
    EMPayrollSelected,
    SubRolePayROllOp,
    API_TYPES,

    APITYPE,
    ReportTypeVal,

    ActiveVal,
    ActiveOptions,
    ActiveFilter,
    NoFilter,
    ApproveRequestFilter, /// for the Approve request
    AdminFilters,
    iscompletedLabel,

    PriorityKeys,
    priorityoptions,
    PriorityValues,
    Nodatarecord,
    Block_listed_filter,
    Block_lists,
    BlockEmp,
    searchVal,
    search_key,
    Separated,
    onChange_ofMonthDate,
    value_of_monthDate,
    Month_date_pick,
  } = props;
  const columns = useMemo(() => props.columns);
  const data = props.data;

  // const [pageSize, setPageSize] = useState(props.dtpagesize || 10);
  const sateusers = useSelector((sateusers) => sateusers);

  ////---Get--sub role--
  //  const UserData = useSelector((state) => state.users.UserData);
  const [SubRoleList, setSubRoleList] = useState();

  useEffect(() => {
    if (sateusers.users.UserData.data != undefined) {
    }
    if (sateusers.users.UserData.session) {
      if (
        sateusers.users.UserData.data != undefined &&
        sateusers.users.UserData.data != null
      ) {
        setSubRoleList(sateusers.users.UserData.data.sub_role);
      }
    }
  }, [sateusers.users]);

  ///console.log( SubRoleList != 0 ,"asdaisdiwausSubRoleList" , Filter);

  const HandleView = (row) => {
    if (MakeCreate) {
      // console.log(row, "ROWS", MakeCreate);
      props.ViewParts(row);
    }
  };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    rowsPerPage,
  } = useTable({
    columns,
    data,
  });

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: props.dtpageindex,
        pageSize: props.dtpagesize,
      },
      manualPagination: true,
      pageCount:
        props.datacount < 20 || props.datacount == null
          ? 1
          : Math.ceil(props.datacount / props.dtpagesize + 1),
    },
    // useFilters,
    // useSortBy,
    // useGlobalFilter,
    // usePagination,
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
  );
  const {
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    state,
    visibleColumns,
    setGlobalFilter,
    preGlobalFilteredRows,
    previousPage,
    setPageSize,

    state: { pageIndex, pageSize },
  } = tableInstance;

  const dropdowntable = () => {
    gotoPage(1);
  };
  // const fetchData = ({ pageSize, pageIndex }) => {
  //   // console.log("fetchData is being called", pageSize, pageIndex);
  //   pageindexloc = pageIndex;
  //    console.log(pageindexloc ,"wqeqweqweqweqw", props.dtpageindex);
  //   if (pageindexloc == 0) {
  //     pageindexloc = 1;
  //   }

  //   props.pagesize(pageSize);
  //   props.pageindex(pageindexloc);
  // };

  // React.useEffect(() => {
  //   fetchData && fetchData({ pageIndex, pageSize });
  // }, [fetchData, pageIndex, pageSize]);

  const [goPage, setGoPage] = useState(1);

  const handlePageChange = (newPage) => {
    props.onPageChange(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    props.onPageSizeChange(newPageSize);
  };

  const [searchQuery, setSearchQuery] = useState(
    search_key ? searchVal || "" : "",
  );

  useEffect(() => {
    if (search_key) {
      setSearchQuery(searchVal || "");
    }
  }, [searchVal, search_key]);

  console.log("searchVal:", searchVal, " | searchQuery:", searchQuery);

  const totalPages = Math.ceil(props.totalItems / 10);

  const handlesearch = (e) => {
    // props.tochange()
    //  gotoPage(1)
    props.onChange(e.target.value);
    setSearchQuery(e.target.value);
    if (props.id === "spe" || props.id === "sym") {
      props.setsno(0);
    }
  };
  const HandleCreate = (e) => {
    props.Oncreate();
  };
  const handleNext = (e) => {
    props.onNextpage(pageIndex);
  };
  const HandlePrevious = (e) => {
    props.onPrevious(e);
  };
  const handleFirstpage = () => {
    props.onFirstPage();
  };

  ///---APi---type
  const HandlereportType = (e) => {
    gotoPage(1);

    if (e != null) {
      props.HandlereportType(e);
    }
  };
  const HandleActiveType = (e) => {
    gotoPage(1);

    if (e != null) {
      props.HandleActiveAPI(e);
    }
  };

  // const handleNextPage = () => {
  //   if (currentPage < totalPages) {
  //     onPageChange(currentPage + 1);
  //   }
  // };

  // const handlePreviousPage = () => {
  //   if (currentPage > 1) {
  //     onPageChange(currentPage - 1);
  //   }
  // };
  // const handlePageChange = (page) => {
  //   onPageChange(page);

  // };
  // console.log(values, "uopjklnm");
  const handleSubmits = (e) => {
    e.preventDefault();
  };
  const handleGotoPage = (e) => {
    e.preventDefault();
  };
  const GotoThePage = () => {
    const goPageNumber = Number(goPage);
    console.log(
      goPageNumber,
      "goPageNumber",
      Math.ceil(
        props.datacount == null ? 1 : props.datacount / props.dtpagesize,
      ),
      pageIndex == Math.ceil(props.datacount / props.dtpagesize),
      pageIndex,
    );

    if (
      Math.ceil(
        props.datacount == null ? 1 : props.datacount / props.dtpagesize,
      ) >= goPageNumber ||
      goPageNumber == ""
    ) {
      if (props.id === "spe" || props.id === "sym") {
        // props.setsno((newPageIndex - 1) * 20);
        props.setsno((goPageNumber - 1) * 20); // Set sno based on the page number
      }
      gotoPage(goPageNumber);
      props.GotoEnteredPage(goPageNumber);
    } else {
      toast.error("Invalid Page Number", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const [count, setcounts] = useState(2);
  const [clear, setClear] = useState(false);
  const HandleSelectFilter = (selectedVal) => {
    // console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setcounts(2);
      props.count(count, selectedVal.label, selectedVal.value, selectedVal);
    }
    if (selectedVal == null) {
      //console.log(selectedVal, "null ", count);
      setcounts(1);
      props.ClearState(count);
    }
  };

  ///---role filter---
  const HandleEMprole = (e) => {
    gotoPage(1);

    if (e != null) {
      props.HandleEMprole(e);
    }
  };

  ///---Payroll---filters--
  const HandlePayrollFilter = (e) => {
    gotoPage(1);

    if (e != null) {
      props.HandlePayrollFilter(e);
    }
  };

  //----Kyc----role
  const HandleKyc = (e) => {
    gotoPage(1);
    props.HandleKyc(e);
  };

  ///--Month filters
  const handleChange = (e) => {
    gotoPage(1);

    if (e != null) {
      props.handleChange(e);
    }
  };
  ///---App side complted filters
  const handlechangescompletd = (e) => {
    if (e != null) {
      props.handlechangescompletd(e);
    }
  };
  //---old employees
  const HandleOldemployee = (e) => {
    gotoPage(1);

    if (e != null) {
      props.HandleOldemployee(e);
    }
  };

  //---old employees
  const HandleBlockemployee = (e) => {
    gotoPage(1);

    props.HandleBlockemployee(e);
  };
  ///---priority

  const HandlethepriorityChanges = (e) => {
    gotoPage(1);
    props.HandlethepriorityChanges(e);

    // if (e != null) {
    //   props.HandlethepriorityChanges(e);
    // }
  };

  //---superviors
  const superviorChanges = (e) => {
    gotoPage(1);

    if (e != null) {
      props.superviorChanges(e);
    }
  };
  ///-----skill assements----
  const HandleParentChnages = (e) => {
    gotoPage(1);

    if (e != null) {
      props.HandleParentChnages(e);
    }
  };

  const preventTyping = (e) => {
    e.preventDefault();
  };
  function onFocus(event) {
    event.target.showPicker();
  }
  const today = new Date().toISOString().slice(0, 7);
  console.log(Nodatarecord, "aspduasod Nodatarecord", KycValue);

  return (
    <>
      <>
        <div className="row no-zoom">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <>
                  {
                    // SubRoleList != 0 &&
                    Filter ? (
                      // MakeCreate

                      <>
                        {/* -----------------Filters------------------ */}
                        <div
                          className={`row tableFilter FilterManagement ${
                            NoFilter ? "placeArange" : "notarange"
                          }`}
                          style={{
                            display: "flex",
                            // justifyContent: "space-between",
                            alignContent: "center",
                            top: "-15px",
                            display: "flex",
                            position: "  relative",
                            justifyContent:
                              Separated == true ? "space-between" : "",
                          }}
                        >
                          {!Search || Search == undefined ? (
                            <div
                              className={`field-div   col-sm-2 ${
                                NoFilter == true
                                  ? "placeArangesearch"
                                  : "notarangesearch"
                              }`}
                            >
                              <label
                                for="validationCustom02"
                                class="form-label FilterLabel"
                              ></label>

                              <div className="inputSearchFiled">
                                <input
                                  type="search"
                                  class=" TableSearch form-control "
                                  placeholder="Search..."
                                  onChange={handlesearch}
                                  value={searchQuery}
                                />

                                <span
                                  class="
border-0  bg-transparent"
                                  id="search-addon"
                                >
                                  <img
                                    src={SearchImg}
                                    width="100%"
                                    height="100%"
                                  />
                                </span>
                              </div>
                            </div>
                          ) : null}
                          {/* </div> */}
                          {/* <div 
//  className="nextPartofRow" 
 > */}
                          {ActiveFilter ? (
                            <div
                              class=" field-div col-sm-2"
                              style={{
                                position: "relative",

                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                              }}
                            >
                              <label
                                for="validationCustom02"
                                class="form-label FilterLabel"
                              >
                                Status
                              </label>

                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  HandleActiveType(e);
                                }}
                                value={ActiveVal}
                                options={ActiveOptions}
                                placeholder="search"
                              />
                            </div>
                          ) : null}
                          {APITYPE ? (
                            <div
                              class=" field-div col-sm-2"
                              style={{
                                position: "relative",

                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                                // width: "351px",
                              }}
                            >
                              <label
                                for="validationCustom02"
                                class="form-label FilterLabel"
                                // style={{ fontSize: "15px" }}
                              >
                                Service Type
                              </label>

                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  HandlereportType(e);
                                }}
                                value={ReportTypeVal}
                                options={API_TYPES}
                                placeholder="search"
                              />
                            </div>
                          ) : null}
                          {EmployeeRoleTrue ? (
                            <div
                              class=" field-div col-sm-2"
                              style={{
                                position: "relative",

                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "5",
                                // width: "351px",
                              }}
                            >
                              <label
                                for="validationCustom02"
                                class="form-label FilterLabel"
                                // style={{ fontSize: "15px" }}
                              >
                                Employee Designation
                              </label>

                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  HandleEMprole(e);
                                }}
                                value={EMpROleSelected}
                                options={EmployeeRoleOption}
                                placeholder="search"
                              />
                            </div>
                          ) : null}
                          {KYC ? (
                            <div
                              class=" field-div col-sm-2"
                              style={{
                                position: "relative",

                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                                // width: "351px",
                              }}
                            >
                              <label
                                for="validationCustom02"
                                class="form-label FilterLabel"
                                // style={{ fontSize: "15px" }}
                              >
                                Kyc Designation
                              </label>

                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  HandleKyc(e);
                                }}
                                value={KycValue}
                                options={KYCoptionsTable}
                                placeholder="search"
                                isDisabled={
                                  EMpROleSelected.value == "2" ? true : false
                                }
                                isClearable={
                                  KycValue?.[0]?.label == "ALL" ||
                                  KycValue?.label == "ALL" ||
                                  KycValue?.label == "All"
                                    ? false
                                    : true
                                }
                              />
                            </div>
                          ) : null}
                          {typeOfParentlist ? (
                            <div
                              class=" field-div col-sm-2"
                              style={{
                                position: "relative",

                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                                // width: "351px",
                              }}
                            >
                              <label
                                for="validationCustom02"
                                class="form-label FilterLabel"
                                // style={{ fontSize: "15px" }}
                              >
                                Skill Assement Type{" "}
                              </label>

                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  HandleParentChnages(e);
                                }}
                                value={EMpHeaderSelected}
                                options={typeOfParent}
                                placeholder="search"
                              />
                            </div>
                          ) : null}{" "}
                          {Month_date_pick ? (
                            <div
                              className="col-sm-3"
                              style={{
                                overflow: "visible",
                                position: "relative",
                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                              }}
                            >
                              <MonthFilter_datepicker
                                label="Month"
                                value={value_of_monthDate}
                                onChange={(values) => {
                                  props.GotoEnteredPage(1);
                                  onChange_ofMonthDate(values);
                                }}
                              />
                            </div>
                          ) : null}
                          {MonthFilter ? (
                            <div
                              className="col-sm-2  field-div"
                              style={{
                                position: "relative",
                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                                // width: "351px",
                                marginTop: "-3px",
                              }}
                            >
                              <label
                                for="validationCustom01"
                                class="form-label FilterLabel"
                              >
                                Month
                              </label>
                              <input
                                type="month"
                                value={yearAndMonth}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                max={today} // Set the max attribute to today's date
                                onKeyDown={preventTyping}
                                onClick={onFocus}
                                style={{ height: "46px" }}
                              />
                            </div>
                          ) : null}
                          {AppSideView ? (
                            <div
                              className="col-sm-2  field-div"
                              style={{
                                position: "relative",

                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                                width: "351px",
                              }}
                            >
                              <label className="FilterLabel from-label">
                                {/* App side completed */}
                                {iscompletedLabel}
                              </label>
                              <Select
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                }}
                                className="Selects"
                                options={optionsforfilter}
                                onChange={handlechangescompletd}
                                value={AllEmp}
                              />
                            </div>
                          ) : null}
                          {OldEmployeFilters ? (
                            <div
                              className="col-sm-2  field-div"
                              style={{
                                position: "relative",

                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                                width: "351px",
                              }}
                            >
                              <label className="from-label FilterLabel">
                                {" "}
                                Employee
                              </label>
                              <Select
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                }}
                                className="Selects"
                                options={oldemloyeeOptions}
                                onChange={(e) => {
                                  HandleOldemployee(e);
                                  gotoPage(1);
                                }}
                                value={OldEmp}
                              />
                            </div>
                          ) : null}
                          {Block_listed_filter ? (
                            <div
                              className="col-sm-2  field-div"
                              style={{
                                position: "relative",

                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                                width: "351px",
                              }}
                            >
                              <label className="from-label FilterLabel">
                                {" "}
                                Blocked List
                              </label>
                              <Select
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                }}
                                className="Selects"
                                options={Block_lists}
                                onChange={(e) => {
                                  HandleBlockemployee(e);
                                  gotoPage(1);
                                }}
                                value={BlockEmp}
                                isClearable={
                                  !BlockEmp || BlockEmp?.value == ""
                                    ? false
                                    : true
                                }
                              />
                            </div>
                          ) : null}
                          {Superviorsfilter ? (
                            <div
                              className="col-sm-2  field-div"
                              style={{
                                position: "relative",

                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                                width: "351px",
                              }}
                            >
                              <label className="from-label FilterLabel">
                                {" "}
                                Superviors
                              </label>
                              <Select
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                }}
                                className="Selects"
                                options={supervisoreOptions}
                                onChange={superviorChanges}
                                value={TypeOfsuperviors}
                              />
                            </div>
                          ) : null}
                          {!OldEmployeFilters &&
                          !NoFilter &&
                          !Superviorsfilter &&
                          SubRoleList != 1 &&
                          !ApproveRequestFilter &&
                          // sateusers.ClientBranchIDs.ApproveRequest == 2 &&
                          !AdminFilters &&
                          !PayrollFilter &&
                          !nostatusFilter ? (
                            <div className="col-sm-2 ">
                              <label
                                for="validationCustom01"
                                class="form-label FilterLabel"
                              >
                                Status
                              </label>
                              <Select
                                className="Selects"
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                  zIndex: "8888",
                                }}
                                // options={options}
                                onChange={(e) => {
                                  HandleSelectFilter(e);
                                }}
                                // onSelect={(e) => setMuliselect3(e)}
                                // onChange={(e) => {
                                // handleZone(e);
                                // }}
                                value={values}
                                options={options}
                                // isClearable={true}
                                isClearable={
                                  values
                                    ? Array.isArray(values)
                                      ? values.some(
                                          (item) =>
                                            item.label === "ALL" ||
                                            item.label === "All",
                                        )
                                        ? false
                                        : true
                                      : values.label === "ALL" ||
                                          values.label === "All"
                                        ? false
                                        : true
                                    : true
                                }
                                labelledBy="Select"
                                placeholder={
                                  values == {} ? placeHold : placeHold
                                }
                              />
                            </div>
                          ) : null}
                          {ApproveRequestFilter ? (
                            <>
                              <div className="col-sm-2 ">
                                <label
                                  for="validationCustom01"
                                  class="form-label FilterLabel"
                                >
                                  Status
                                </label>
                                <Select
                                  className="Selects"
                                  styles={{
                                    position: "relative",
                                    top: "60px",
                                    zIndex: "8888",
                                  }}
                                  // options={options}
                                  onChange={(e) => {
                                    HandleSelectFilter(e);
                                  }}
                                  // onSelect={(e) => setMuliselect3(e)}
                                  // onChange={(e) => {
                                  // handleZone(e);
                                  // }}
                                  value={values}
                                  options={options}
                                  isClearable={
                                    values
                                      ? Array.isArray(values)
                                        ? values.some(
                                            (item) =>
                                              item.label === "ALL" ||
                                              item.label === "All",
                                          )
                                          ? false
                                          : true
                                        : values.label === "ALL" ||
                                            values.label === "All"
                                          ? false
                                          : true
                                      : true
                                  }
                                  labelledBy="Select"
                                  placeholder={
                                    values == {} ? placeHold : placeHold
                                  }
                                />
                              </div>
                            </>
                          ) : null}
                          {PayrollFilter ? (
                            <div class="col-sm-2 field-div">
                              <label
                                for="validationCustom02"
                                class="form-label FilterLabel"
                              >
                                Status
                              </label>

                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  HandlePayrollFilter(e);
                                }}
                                value={EMPayrollSelected}
                                options={SubRolePayROllOp}
                                placeholder="search"
                              />
                            </div>
                          ) : null}
                          {!OldEmployeFilters &&
                          !Superviorsfilter &&
                          SubRoleList == 1 &&
                          RMStatusFilter &&
                          !nostatusFilter ? (
                            <div className="col-sm-2 ">
                              <label
                                for="validationCustom01"
                                class="form-label FilterLabel"
                              >
                                {/* Rm Filter */}
                                Status
                              </label>
                              <Select
                                className="Selects"
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                  zIndex: "8888",
                                }}
                                onChange={(e) => {
                                  props.Rmfilter03(e);
                                }}
                                value={Rmfilter}
                                options={Rmoptions}
                                // isClearable={true}
                                isClearable={
                                  Rmfilter
                                    ? Array.isArray(Rmfilter)
                                      ? Rmfilter.some(
                                          (item) =>
                                            item.label === "ALL" ||
                                            item.label === "All",
                                        )
                                        ? false
                                        : true
                                      : Rmfilter.label === "ALL" ||
                                          Rmfilter.label === "All"
                                        ? false
                                        : true
                                    : true
                                }
                                labelledBy="Select"
                                placeholder={"Select"}
                              />
                            </div>
                          ) : null}
                          {PriorityKeys ? (
                            <div
                              className="col-sm-2  field-div"
                              style={{
                                position: "relative",

                                display: "flex",
                                justifyContent: "flex-end",
                                flexDirection: "column",
                                zIndex: "1",
                                width: "351px",
                              }}
                            >
                              <label className="from-label FilterLabel">
                                Priority
                              </label>
                              <Select
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                }}
                                className="Selects"
                                options={priorityoptions}
                                onChange={(e) => {
                                  HandlethepriorityChanges(e);
                                  gotoPage(1);
                                }}
                                value={PriorityValues}
                                isClearable={true}
                              />
                            </div>
                          ) : null}
                        </div>
                        {/* </div> */}
                      </>
                    ) : null
                  }
                </>
                <div className="table-responsive">
                  <div className="INNERTABLE">
                    <table {...getTableProps()} className="TableDesgin">
                      <thead>
                        {headerGroups.map((headerGroup) => (
                          <tr
                            {...headerGroup.getHeaderGroupProps()}
                            className="innerHead"
                          >
                            {headerGroup.headers.map((column) => (
                              <th
                                {...column.getHeaderProps()}
                                // (Nodatarecord != undefined && column.Header == "Created Date")
                                //             ? column.getSortByToggleProps()
                                //             : {}
                                //   style={{
                                //     cursor: (Nodatarecord != undefined && column.Header === "Created Date") ? 'pointer' : 'default'
                                // }}
                              >
                                {column.render("Header")}

                                {/* {( column.Header === "Created Date") && (
                                        <span>
                                            {column.isSorted
                                                ? column.isSortedDesc
                                                    ? " 🔽" // If sorted descending, show 🔽
                                                    : " 🔼" // If sorted ascending, show 🔼
                                                : " 🔽"}


                                        </span>
                                    )} */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      {data != undefined &&
                      page.length > 0 &&
                      data.length > 0 ? (
                        <tbody {...getTableBodyProps()} className="tbodyReact">
                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <tr
                                {...row.getRowProps()}
                                className={`InnerBodyTR ${
                                  MakeCreate ? "Cursor" : ""
                                }`}
                                onClick={(e) => HandleView(row.original)}
                              >
                                {row.cells.map((cell) => {
                                  return (
                                    <td {...cell.getCellProps()}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                      ) : (
                        <>
                          {/* <td colSpan="8" style={{ textAlign: "center" }}>
                          No data available
                          </td> */}
                        </>
                      )}
                    </table>
                    <>
                      {data != undefined &&
                      page.length > 0 &&
                      data.length > 0 ? (
                        <></>
                      ) : (
                        <>
                          <div>
                            <div className="Dusbinbacktabls">
                              <div>
                                <img src={boximg} />
                                <p className="text-center">
                                  {Nodatarecord != undefined
                                    ? Nodatarecord
                                    : "No Data Available"}
                                  {/* {"No Data Available"} */}
                                </p>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  </div>
                  <div
                    className="row"
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      margin: "0",
                    }}
                  >
                    {props.datacount > 20 ? (
                      <div
                        className="pagination"
                        style={{ justifyContent: "end", width: "100%" }}
                      >
                        <div
                          className=" pagination"
                          style={{ justifyContent: "end" }}
                        >
                          <div className="showrow1" style={{ padding: "4px" }}>
                            {/* <button
                              className="btn btn prim"
                              style={{ border: "none" }}
                              onClick={() => {

                                // gotoPage(1);
                                // if (props.id == "spe" || props.id == "sym") {
                                //   props.setsno(1);
                                // }
                                gotoPage(1);
                                console.log(pageIndex, "pageIndex");
                                if (props.id === "spe" || props.id === "sym") {
                                  props.setsno(0);
                                }
                              }}
                              disabled={pageIndex == 1}
                            >
                              {"<<"}
                            </button> */}
                            <button
                              className="btn btn prim"
                              style={{ border: "none" }}
                              onClick={() => {
                                HandlePrevious(props.dtpageindex - 1);
                                // previousPage();
                                if (props.id == "spe" || props.id == "sym") {
                                  props.setsno(props.sno - 20);
                                }
                              }}
                              disabled={pageIndex == 1}
                            >
                              {"<"}
                            </button>
                            <span style={{ padding: "10px" }}>
                              {/* <strong style={{ fontSize: "12px" }}>
                                <input
                                  value={pageIndex}
                                  style={{ width: "45px" }}
                                  onChange={(e) => {

                                    if (
                                      props.id == "spe" ||
                                      props.id == "sym"
                                    ) {
                                      props.setsno((page - 1) * 10 + 1);
                                    }

                                    gotoPage(e.target.value);
                                  }}
                                />{" "}
                                of{" "}
                                {Math.ceil(
                                  props.datacount == null
                                    ? 1
                                    : props.datacount / props.dtpagesize
                                )}{" "}
                              </strong> */}

                              <strong style={{ fontSize: "12px" }}>
                                {/* <input
                                  type="number"
                                  value={pageIndex}
                                   className="TableInputfield"
                                  // onChange={(e) => {
                                  //   const newPageIndex = Number(e.target.value);

                                  //   if (
                                  //     !isNaN(newPageIndex) &&
                                  //     newPageIndex > 0
                                  //   ) {
                                  //     if (
                                  //       props.id === "spe" ||
                                  //       props.id === "sym"
                                  //     ) {
                                  //       props.setsno((newPageIndex - 1) * 10);
                                  //     }

                                  //     gotoPage(newPageIndex);
                                  //   }

                                  // }}
                                   disabled
                                />{" "} */}
                                {pageIndex} of{" "}
                                {Math.ceil(
                                  props.datacount == null
                                    ? 1
                                    : props.datacount / props.dtpagesize,
                                )}{" "}
                              </strong>
                            </span>

                            <button
                              style={{ border: "none" }}
                              className="btn btn prim"
                              onClick={() => {
                                // handleNext()
                                // nextPage();
                                handleNext(props.dtpageindex + 1);

                                if (props.id == "spe" || props.id == "sym") {
                                  props.setsno(props.sno + 20);
                                }
                              }}
                              disabled={
                                pageIndex ==
                                Math.ceil(props.datacount / props.dtpagesize)
                              }
                            >
                              {">"}
                            </button>
                            {/* <button
                              style={{ border: "none" }}
                              className="btn btn prim"
                              onClick={() => {
                                // gotoPage(
                                //   Math.ceil(props.datacount / props.dtpagesize)
                                // );
                                // if (props.id == "spe" || props.id == "sym") {
                                //   props.setsno(props.sno + 10);
                                // }

                                const lastPage = Math.ceil(
                                  props.datacount / props.dtpagesize
                                );
                                gotoPage(lastPage);
                                if (props.id == "spe" || props.id == "sym") {
                                  props.setsno((lastPage - 1) * 10);
                                }
                              }}
                              disabled={
                                pageIndex ==
                                Math.ceil(props.datacount / props.dtpagesize)
                              }
                            >
                              {">>"}
                            </button> */}
                            <span className="GOTOPageOuters">
                              <form
                                className="GotoPageForm"
                                onSubmit={handleGotoPage}
                              >
                                <span className="GotoPageText">Go to Page</span>
                                <input
                                  type="number"
                                  value={goPage}
                                  className="formcontrol_Table"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const newPageIndex = e.target.value;
                                    console.log(
                                      newPageIndex,
                                      "newPageIndex",
                                      !isNaN(newPageIndex),
                                    );

                                    if (!isNaN(newPageIndex)) {
                                      // if (
                                      //   props.id === "spe" ||
                                      //   props.id === "sym"
                                      // ) {
                                      //   props.setsno((newPageIndex - 1) * 20);
                                      // }
                                      if (
                                        newPageIndex != 0 &&
                                        newPageIndex > 0
                                      ) {
                                        setGoPage(newPageIndex);
                                      } else if (
                                        newPageIndex == 0 ||
                                        newPageIndex < 0
                                      ) {
                                        setGoPage("");
                                      }
                                    }
                                  }}
                                  step="1"
                                  onKeyDown={(evt) => {
                                    if (
                                      ["e", "E", "+", "-", "."].includes(
                                        evt.key,
                                      )
                                    ) {
                                      evt.preventDefault();
                                    }
                                  }}
                                />

                                <button
                                  type="submit"
                                  className="GOBTON btn"
                                  disabled={goPage == ""}
                                  onClick={(e) => {
                                    GotoThePage();
                                  }}
                                >
                                  Go
                                </button>
                              </form>
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ReactTable;
